import mime from 'mime';
import { getFileLink, getFileName } from '../../helpers/uploader';
import { IUploaderFileResponse } from '../../types/components/uploader';
import UploaderDeleteButton from './delete-button';

interface IUploadedFileProps {
    file: IUploaderFileResponse;
    onDeleteClick: (id: string) => void;
    idOwner: any;
}

function UploadedFile({ file, onDeleteClick, idOwner }:IUploadedFileProps) {
    const isImage = mime.getType(file.name)?.includes('image');

    const renderLink = () => {
        if (isImage) {
            return (
                <button
                    className="btn btn-link p-0"
                    data-bs-toggle="modal"
                    data-bs-target={`#image-view-modal-${file.idFile}`}
                    type="button"
                >
                    {getFileName(file)}
                </button>
            );
        }
        return (
            <a href={getFileLink(file.idFile, idOwner)} target="blank">{getFileName(file)}</a>
        );
    };

    return (
        <div className="p-2">
            {renderLink()}
            <UploaderDeleteButton file={file} onDeleteClick={() => onDeleteClick(file.idFile)} />
            {isImage && (
                <div className="modal image-view-modal" id={`image-view-modal-${file.idFile}`} aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <button
                                className="btn btn-link image-view-modal-close-btn"
                                data-bs-dismiss="modal"
                                type="button"
                            >
                                <i className=" fas fa-close nav-icon" />
                            </button>
                            <img
                                alt={file.name}
                                src={getFileLink(file.idFile, idOwner)}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default UploadedFile;
